export class SkipFieldConstants {
    //Check form dirty to avoid these fields compare
    static readonly JOB_APPLICATION_FORM = [
        'id', 'files', 'orgid', 'tenantid', 'byteafiles', 'profilepicdata', 'profilepicuploaded', 'profilepicuploadkey', 'resumeuploadkey', 'resumeuploaded'
    ];

    static readonly JOB_APPLICATION_DATE_FORM = [
        'dob', 'startdt', 'enddt', 'dateofrelieving'
    ];

    static readonly ONBOARD_FORM = [
        'id', 'candidateid', 'appid', 'files', 'orgid', 'tenantid', 'pancard', 'ssn', 'photograph', 'passport', 'pancardmultipart', 'ssnmultipart', 'photographmultipart', 'passportmultipart', 'pancardtemploc', 'ssntemploc', 'photographtemploc', 'employmentapplicationform', 'bgvform', 'joiningform', 'pfuan', 'medicalreport', 'conflictofinterestform', 'confidentialityform', 'filecontent'
    ];
    static readonly ONBOARD_DATE_FORM = [
        'father_dob', 'mother_dob', 'spouse_dob', 'fatherinlaw_dob', 'motherinlaw_dob', 'dob'
    ];
}